import { Link } from "react-router-dom";
import type { CrumbItem } from "@/types";

interface BreadcrumbProps {
  items: CrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center flex-wrap gap-1 text-sm text-foreground-500">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={`${item.label}-${index}`} className="flex items-center gap-1">
            {item.to && !isLast ? (
              <Link to={item.to} className="hover:text-primary-600 transition-colors cursor-pointer">
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? "text-foreground-900 font-medium" : ""}>{item.label}</span>
            )}
            {!isLast && <i className="ri-arrow-right-s-line text-foreground-400"></i>}
          </span>
        );
      })}
    </nav>
  );
}